/** Markdown primitive editor — a plain textarea (the v1 line; no block editor). */
import type { ProposalFieldEditorProps } from "../ProposalEditor.js";
import { controlStyle, fieldDomId } from "../ProposalEditor.js";

export function MarkdownField({ field, value, onChange, idPrefix }: ProposalFieldEditorProps) {
  return (
    <textarea
      id={fieldDomId(idPrefix, field.key)}
      aria-label={field.label}
      rows={5}
      style={{ ...controlStyle, resize: "vertical", lineHeight: 1.5 }}
      value={value == null ? "" : String(value)}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
